module.exports = __webpack_public_path__ + "img/airline_seat_legroom_extra.d3762346.svg";